export const Sort = ({
  size = 14,
  color = 'currentColor',
  className,
  direction,
}: {
  size?: number;
  color?: string;
  className?: string;
  direction?: string | number;
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}>
    <path
      d="M4 5L7 1L10 5"
      stroke={color}
      opacity={direction === 'desc' ? 0.6 : 1}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4 9L7 13L10 9"
      stroke={color}
      opacity={direction === 'asc' ? 0.6 : 1}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
